module.exports = "https://static-www.niulinkcloud.com/_next/static/media/pcBanner.4e96b4961f1e28fba95de5b830803047.png";